import React, { useEffect, useRef } from 'react';
import RequestedShiftGroup from '../../../features/shiftsToRequest/RequestedShiftGroup';
import { computeTotalShiftsToCreate } from '../../../hooks/useShiftsForm';

const DEFAULT_HEADER = 'Shift details and dates';

const ShiftsForm = ({
	headerText = DEFAULT_HEADER,
	infoText,
	shiftsGroups,
	updateShift,
	removeShift,
	addEmptyShiftGroup,
	errors,
	currentShiftStructures,
	isFlex,
	isHybrid,
	isGlobalCalendar,
	selectedFacility,
	showUnits,
	currentFacilityUnits,
	maxShiftsToCreate,
	checkIfCanAddTodayShiftForStructure,
	isMobile,
	hideProvidersCount,
	getDateConflict,
	allowPastDates = false
}) => {
	const sectionRef = useRef();
	const previousShiftsGroupsLengthRef = useRef(shiftsGroups.length);

	useEffect(() => {
		if (shiftsGroups.length > previousShiftsGroupsLengthRef.current) {
			sectionRef.current?.lastElementChild?.scrollIntoView({ behavior: 'smooth' });
		}
		previousShiftsGroupsLengthRef.current = shiftsGroups.length;
	}, [shiftsGroups.length]);

	const { portal_units_enabled: facilityPortalUnitsEnabled } = selectedFacility || {};

	const canAddAnotherShift =
		!!selectedFacility?.id &&
		Math.max(shiftsGroups.length, computeTotalShiftsToCreate(shiftsGroups)) < maxShiftsToCreate;

	return (
		<div ref={sectionRef} className="shifts-section">
			<div className="section-header">{headerText}</div>
			{infoText && <div className="section-info">{infoText}</div>}
			{shiftsGroups.map((shiftsGroup, index) => (
				<RequestedShiftGroup
					key={`shift${shiftsGroup.id}`}
					availableShiftStructures={currentShiftStructures}
					allowRemove={shiftsGroups.length > 1}
					shiftsGroups={shiftsGroups}
					updateShift={updateShift}
					shiftIndex={index}
					errors={errors[shiftsGroup.id] || {}}
					removeShift={removeShift}
					shift={shiftsGroup}
					isFlex={isFlex}
					isHybrid={isHybrid}
					isGlobalCalendar={isGlobalCalendar}
					currentFacility={selectedFacility?.id}
					allowPastDates={allowPastDates}
					showUnits={showUnits}
					units={currentFacilityUnits}
					facilityPortalUnitsEnabled={facilityPortalUnitsEnabled}
					maxShiftsToCreate={maxShiftsToCreate}
					checkIfCanAddTodayShiftForStructure={checkIfCanAddTodayShiftForStructure}
					isMobile={isMobile}
					hideProvidersCount={hideProvidersCount}
					getDateConflict={getDateConflict}
				/>
			))}
			<button type="button" className="add-shift-button" onClick={addEmptyShiftGroup} disabled={!canAddAnotherShift}>
				+ Add another shift
			</button>
		</div>
	);
};

export default ShiftsForm;
